import { selectColumnId } from 'types/myProductColumnIds'
import { TableColumn } from '../../../../types/tableTypes'
import { TableSelectCell } from '../../../widgets/productsTable/components/tableSelectCell'

export function createUniversalColumns<
  TColumnId extends string,
  TRow extends object
>(
  baseColumns: TableColumn<TColumnId, TRow>[],
  hiddenIds: Set<string>
): TableColumn<TColumnId, TRow>[] {
  const visibleColumns = baseColumns.filter(column => !hiddenIds.has(column.id))

  const selectColumn: TableColumn<TColumnId, TRow> = {
    // eslint-disable-next-line no-type-assertion/no-type-assertion
    id: selectColumnId as TColumnId,
    title: 'Выбрать',
    accessor: () => undefined,
    CellComponent: TableSelectCell
  }

  return [selectColumn, ...visibleColumns]
}
